import { useIntl } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { FlippingIconIncrement } from 'atoms/animations/FlippingIconIncrement';
import { ArenaButton } from 'atoms/buttons/specials/ArenaButton';
import { SimpleTicket } from 'atoms/icons/rivals/branded/SimpleTicket';
import { LabelL } from 'atoms/typography';
import { rivals } from 'lib/glossary';

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  20% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.1);
  }
  40% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
`;

const TicketButton = styled(ArenaButton)`
  &.animate {
    animation: ease-in-out 2s infinite ${pulseAnimation};
  }
`;
const StyledLabelL = styled(LabelL)`
  font-variant-numeric: tabular-nums;
`;

export type Props = {
  onClick: () => void;
  remainingArenaRequests: number;
};

export const DailyClaimButton = ({
  onClick,
  remainingArenaRequests,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <TicketButton
      size="medium"
      onClick={onClick}
      title={formatMessage(rivals.arenaTickets)}
    >
      <FlippingIconIncrement
        value={remainingArenaRequests}
        renderNumberIncrement={animationProps => (
          <StyledLabelL as="span" bold>
            <AnimatedNumber
              value={remainingArenaRequests}
              animationProps={animationProps}
            />
          </StyledLabelL>
        )}
      >
        <SimpleTicket variant="claimed" />
      </FlippingIconIncrement>
    </TicketButton>
  );
};
